import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Sidebar() {
  const { user } = useAuth();
  const location = useLocation();
  const enabledModules = user?.modules || [];
  const inboundEnabled = enabledModules.includes('inbound');

  const isDomainAdmin = location.pathname.startsWith('/domain-admin');
  const [domainAdminOpen, setDomainAdminOpen] = useState(isDomainAdmin);
  const [collapsed, setCollapsed] = useState(true);

  // Auto-expand when navigating to a domain-admin route
  React.useEffect(() => {
    if (isDomainAdmin) setDomainAdminOpen(true);
  }, [isDomainAdmin]);

  return (
    <div className={`portal-sidebar${collapsed ? ' sidebar-collapsed' : ''}`}>
      <button
        className="sidebar-toggle"
        onClick={() => setCollapsed((v) => !v)}
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {collapsed ? '\u25B8' : '\u25C2'}
      </button>

      <nav className="sidebar-nav">
        {inboundEnabled && (
          <>
            {/* Domain-Admin collapsible section */}
            <div
              className={`sidebar-link sidebar-section${isDomainAdmin ? ' active' : ''}`}
              onClick={() => setDomainAdminOpen((v) => !v)}
            >
              <span className="sidebar-icon">{'\u2699'}</span>
              {!collapsed && <span className="sidebar-label">Domain-Admin</span>}
              {!collapsed && (
                <span className={`sidebar-chevron${domainAdminOpen ? ' open' : ''}`}>
                  {'\u25B8'}
                </span>
              )}
            </div>

            {domainAdminOpen && !collapsed && (
              <div className="sidebar-submenu">
                <NavLink to="/domain-admin/addresses" className="sidebar-sublink">
                  Support Addresses
                </NavLink>
                <NavLink to="/domain-admin/staff" className="sidebar-sublink">
                  Team
                </NavLink>
                <NavLink to="/domain-admin/groups" className="sidebar-sublink">
                  Groups
                </NavLink>
              </div>
            )}

            {/* Tickets standalone */}
            <NavLink to="/tickets" className="sidebar-link">
              <span className="sidebar-icon">{'\u2709'}</span>
              {!collapsed && <span className="sidebar-label">Tickets</span>}
            </NavLink>
          </>
        )}
      </nav>
    </div>
  );
}
